export default function uniqueFromArray(array = [], arrayOther = []) {
    return array.filter(el => arrayOther.findIndex(elInner => elInner.id === el.id) < 0)
}
